import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { LETTER_TEMPLATE_CONTROLLER } from "api/Service";

export const useCreateLetterTemplate = () => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (templateData) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}${LETTER_TEMPLATE_CONTROLLER}`,
        templateData,
        { headers: { "Content-Type": "application/json" } }
      );

      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["letterTemplatesAll"] });
    },
  });
};
